import { render, staticRenderFns } from "./switchBar.vue?vue&type=template&id=c34ed3a6&scoped=true"
import script from "./switchBar.vue?vue&type=script&lang=js"
export * from "./switchBar.vue?vue&type=script&lang=js"
import style0 from "./switchBar.vue?vue&type=style&index=0&id=c34ed3a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34ed3a6",
  null
  
)

export default component.exports